<template>
	<div class="login">
		<h1>免费注册</h1>
		<section class="login_nei" v-if="isRegsit">
			<form action="">
				<div class="login_input flex zhong ">
					<img src="../../image/login_a.png" />
					<input type="text" placeholder="请输入手机号" v-model.trim="zcmodel.Phone" />
				</div>
				<div class="login_input flex zhong ">
					<img src="../../image/login_b.png" />
					<input type="password" placeholder="密码由6-20位字符组成" v-model.trim="zcmodel.Password" />
				</div>
				<!-- 02-21 -->
				<div class="login_input flex zhong " style="position: relative;">
					<img src="../../image/san/ia.png" />
					<input type="number" placeholder="请输入数字验证码" v-model="idCode" />
					<div class="shu_div" @click="refreshCode">
						<identify-div :identifyCode="identifyCode"></identify-div>
					</div>
				</div>
				<div class="login_input flex zhong ">
					<img src="../../image/login_b.png" />
					<input type="number" placeholder="请输入短信验证码" v-model="code" />
					<button type="button" class="sendCode" @click="sendMessage">{{ btnText }}</button>
				</div>
				
				<div class="login_box flex zhong">
					<input type="checkbox" v-model="isAgree" />
					<p>
						同意
						<span @click="agree">《用户服务协议》</span>
					</p>
				</div>
				<el-button type="primary" class="btn" @click="downClick">注册</el-button>
				<hgroup class="flex center"><span @click="goBack">已有账号,立即登录</span></hgroup>
			</form>
		</section>

		<section class="login_nei login_neiForm" v-else>
			<form action="">
				<ul>
					<li class="zhong float flex">
						<label>
							<span>*</span>
							考生姓名：
						</label>
						<div class="regsit_div">
							<div class="login_input flex zhong "><input type="text" placeholder="请输入考生姓名"
									v-model.trim="zcmodel.Name" /></div>
						</div>
					</li>
					<li class="zhong float flex">
						<label>
							<span>*</span>
							考生性别：
						</label>
						<div class="regsit_div flex">
							<div class="regsit_radio flex">
								<input type="radio" name="sex" checked v-model.number="zcmodel.Gender" value="1"
									id="male" @click="setGender(1)" />
								<label for="male">男</label>
							</div>
							<div class="regsit_radio flex">
								<input type="radio" name="sex" v-model.number="zcmodel.Gender" value="2" id="female"
									@click="setGender(2)" />
								<label for="female">女</label>
							</div>
						</div>
					</li>
					<li class="zhong float flex">
						<label>
							<span>*</span>
							考生类型：
						</label>
						<div class="regsit_div flex">
							<div class="regsit_radio flex">
								<input type="radio" name="subject" checked v-model.number="zcmodel.Type" value="1"
									id="wenke" @click="setType(1)" />
								<label for="wenke">文科或选历史</label>
							</div>
							<div class="regsit_radio flex">
								<input type="radio" name="subject" v-model.number="zcmodel.Type" value="2" id="like"
									@click="setType(2)" />
								<label for="like">理科或选物理</label>
							</div>
							<div class="regsit_radio flex">
								<input type="radio" name="subject" v-model.number="zcmodel.Type" value="3" id="bufen"
									@click="setType(3)" />
								<label for="bufen">文理不分科</label>
							</div>
						</div>
					</li>
					<li class="zhong float flex">
						<label>
							<span>*</span>
							高考年份：
						</label>
						<div class="regsit_div">
							<el-select v-model="zcmodel.CollegeYear" placeholder="选择高考年份" class="years"
								style="width: 320px;">
								<el-option v-for="item in yearArr" :key="item" :label="item + '年'" :value="item">
								</el-option>
							</el-select>
						</div>
					</li>
					<li class="zhong float flex">
						<label>
							<span>*</span>
							所在地：
						</label>
						<div class="regsit_div flexFloat">
							<!-- <template v-if="pcaa">
								<area-select :level="2" v-model="selected" :data="pcaa"></area-select>
							</template> -->
							<div style="width: 320px;" class="flexFloat">
								<div style="width: 32%;">
									<el-select v-model="province" placeholder="请选择" @change="setProvince">
										<el-option v-for="item1 in provinceList" :key="item1.Id" :label="item1.Name"
											:value="item1.Id"></el-option>
									</el-select>
								</div>
								<div style="width: 32%;">
									<el-select v-model="city" placeholder="请选择" @change="setCity">
										<el-option v-for="item2 in cityList" :key="item2.code" :label="item2.name"
											:value="item2.code"></el-option>
									</el-select>
								</div>
								<div style="width: 32%;">
									<el-select v-model="area" placeholder="请选择" @change="setArea">
										<el-option v-for="item3 in areaList" :key="item3.code" :label="item3.name"
											:value="item3.code"></el-option>
									</el-select>
								</div>
							</div>
						</div>
					</li>

					<li class="zhong float flex">
						<label>
							<!-- <span>*</span> -->
							学校：
						</label>
						<div class="regsit_div">
							<el-select v-model="school" placeholder="选择学校" class="years" style="width: 320px;">
								<el-option v-for="(item,index) in schoolList" :key="index" :label="item" :value="item">
								</el-option>
								<el-option label="其他" value="其他"></el-option>
							</el-select>
						</div>
					</li>
					<li class="zhong float flex" v-show="schoolInputVisible">
						<label>
							<span>*</span>
							学校名称：
						</label>
						<div class="regsit_div">
							<div class="login_input flex zhong "><input type="text" placeholder="请输入学校名称"
									v-model.trim="zcmodel.School" /></div>
						</div>
					</li>

					<li class="zhong  flex">
						<label>我的规划师：</label>
						<div class="regsit_div">
							<el-select v-model="zcmodel.TeacherId" clearable placeholder="选择规划师" style="width: 320px;">
								<el-option v-for="item in optionsb" :key="item.Id" :label="item.Name" :value="item.Id">
								</el-option>
							</el-select>
						</div>
					</li>
					<li class="zhong float flex" >
						<label>
							邀请码：
						</label>
						<div class="regsit_div">
							<div class="login_input flex zhong "><input type="text" placeholder="请输入邀请码" v-model="zcmodel.InvitationCode"/></div>
						</div>
					</li>
					<li class="zhong float flex">
						<label></label>
						<div class="regsit_div">
							<p>{{ notice }}</p>
						</div>
					</li>
					<li class="zhong float flex">
						<label></label>
						<div class="regsit_div">
							<el-button type="primary" class="btn" @click="submitClick()">保存</el-button>
						</div>
					</li>
				</ul>
			</form>
		</section>
	</div>
</template>
<script>
	// import 'vue-area-linkage/dist/index.css';
	import identifyDiv from '@/components/global/identifyDiv/identifyDiv.vue';
	import {
		citysData
	} from '../../utils/citydata.js';
	export default {
		name: 'login',
		components: {
			identifyDiv
		},
		data() {
			return {
				idYq: '',
				isAgree: true,
				isRegsit: true,
				code: '',
				btnDisabled: false,
				btnText: '获取验证码',
				// 02
				school: '',
				pcaa: null,
				selected: [],
				zcmodel: {
					Phone: '',
					Password: '',
					Source: 2,
					Name: '',
					Gender: 1,
					Type: 1,
					CollegeYear: new Date().getFullYear() + '',
					CityCode: '',
					School: '',
					TeacherId: null,
					InvitationCode:''
				},
				UserInfo: {},
				timer: null,
				downCount: 60,
				yearArr: [],
				schoolInputVisible: false,
				lock: false,
				schoolList: [],
				notice: '',
				identifyCodes: '1234567890',
				identifyCode: '',
				idCode: '',
				optionsb: [],
				valueb: '',
				provinceList: [],
				cityList: [],
				areaList: [],
				province: '',
				city: '',
				area: ''
			};
		},
		created() {
			this.getNotice();
			this.filterProvince();
			this.yearArr = [];
			const startYear = new Date().getFullYear();
			for (let i = 0; i < 21; i++) {
				const year = startYear + i + '';
				this.yearArr.push(year);
			}
		},
		watch: {
			school: {
				handler(newVal) {
					this.schoolInputVisible = newVal === '其他';
					if (!this.schoolInputVisible) {
						this.zcmodel.School = newVal;
					}
				}
			},
			area: {
				handler(newVal) {
					if (newVal.length > 2) {
						const code = Number(newVal);
						this.schoolList = [];
						this.$api
							.getSchoolByArea({
								code
							})
							.then(res => {
								this.schoolList = res.data;
							});
					}
				}
			}
		},
		mounted() {
			this.identifyCode = '';
			this.makeCode(this.identifyCodes, 4);
			this.getPlaner();
			this.getCurrentRegion();
		},
		methods: {
			setType(type) {
				this.zcmodel.Type = type;
			},
			setGender(gender) {
				this.zcmodel.Gender = gender;
			},
			setProvince() {
				console.log(this.province);
				var that = this;
				that.cityList = [];
				that.areaList = [];
				that.city = '';
				that.area = '';
				// 获取市列表
				if (citysData && citysData.length > 0) {
					citysData.map(a => {
						if (parseInt(a.code) === parseInt(that.province)) {
							that.cityList = a.citys;
							console.log(a);
						}
					});
				}
			},
			setCity() {
				var that = this;
				that.areaList = [];
				that.area = '';
				// 获取区县列表
				if (that.cityList && that.cityList.length > 0) {
					that.cityList.map(a => {
						if (parseInt(a.code) === parseInt(that.city)) {
							that.areaList = a.areas;
							console.log(that.areaList);
						}
					});
				}
			},
			setArea() {
				var that = this;
				console.log(that.province, that.city, that.area);
			},
			getCurrentRegion() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/CurrentRegion',
					'GET', {},
					function(res) {
						console.log('当前加盟商的省份', res);
						if (res.code === 0) {
							that.provinceList = res.data;
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			getPlaner() {
				var that = this;
				that.$api.HtppRequest(
					'user/Planer',
					'GET', {},
					function(res) {
						console.log('获取到的规划师', res);
						if (res.code === 0) {
							that.optionsb = res.data;
							console.log('optionsb', that.optionsb);
							// alert(JSON.stringify(that.optionsb))
						}
					},
					function(err) {
						console.log(err);
					}
				);
			},
			randomNum(min, max) {
				return Math.floor(Math.random() * (max - min) + min);
			},
			refreshCode() {
				this.identifyCode = '';
				this.makeCode(this.identifyCodes, 4);
			},
			makeCode(o, l) {
				for (let i = 0; i < l; i++) {
					this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)];
				}
				console.log(this.identifyCode);
			},
			// 获取提示内容
			getNotice() {
				this.$api.getRegisterNotice().then(res => {
					this.notice = res.data;
				});
			},
			// 过滤省份
			filterProvince() {
				this.pcaa = this.$util.filterProvince();
				console.log('filterProvince -> this.pcaa', this.pcaa);
			},
			// 点击下一步
			downClick() {
				var that = this;
				if (!this.zcmodel.Phone) {
					this.$util.showError('请输入手机号');
					return;
				}
				if (!this.$util.validatePhone(this.zcmodel.Phone)) {
					this.$util.showError('请输入合法手机号');
					return;
				}
				if (!this.zcmodel.Password) {
					this.$util.showError('请输入密码');
					return;
				}
				if (this.zcmodel.Password.length < 6 || this.zcmodel.Password.length > 20) {
					this.$util.showError('密码长度为6-20位');
					return;
				}
				console.log('this.idCode', this.idCode);
				if (!this.idCode) {
					this.$util.showError('请输入数字验证码');
					return;
				}
				if (this.idCode != this.identifyCode) {
					this.$util.showError('数字验证码不正确');
					return;
				}
				if (!this.code) {
					this.$util.showError('请输入验证码');
					return;
				}
				if (!this.isAgree) {
					this.$util.showError('请同意用户协议');
					return;
				}
				this.isRegsit = false;
				that.setRegister();
				that.$api
					.verifyCode({
						phone: that.zcmodel.Phone,
						code: that.code
					})
					.then(res => {
						console.log('下一步', res);
						if (res.code === 0) {
							this.isRegsit = false;
							that.setRegister();
						} else {
							that.$util.showError(res.msg);
						}
					})
					.catch(err => {
						console.log('downClick -> err', err);
					});
			},
			setRegister() {
				var that = this
				if (that.isCke) {
					return;
				}
				that.isCke = true;
				// console.log('注册', that.zcmodel);
				that.$api
					.register(that.zcmodel)
					.then(res => {
						that.isCke = false;
						// this.$util.showOk(res.msg);
						that.zcmodel.TeacherId = null;
						that.UserInfo = res.data;
						that.isRegsit = false;
					})
					.catch(err => {
						that.isCke = false;
						that.lock = false;
						console.error('validateRegister -> err', err);
					});
			},
			// 用户服务协议
			agree() {
				this.$router.push('/agree');
			},
			// 已有账号
			goBack() {
				this.$router.push('/login');
			},
			// 发送验证码
			sendMessage() {
				if (this.btnDisabled) {
					return;
				}
				if (!this.zcmodel.Phone) {
					this.$util.showError('请输入手机号');
					return;
				}
				if (!this.$util.validatePhone(this.zcmodel.Phone)) {
					this.$util.showError('请输入合法手机号');
					return;
				}
				this.btnDisabled = true;
				this.$api
					.getPhoneCode({
						phone: this.zcmodel.Phone,
						type: 1
					})
					.then(res => {
						this.$util.showMsg(res.code === 0, res.msg);
						if (res.code === 0) {
							console.log(res);
							this.timer = setInterval(() => {
								this.btnText = '重新获取(' + this.downCount + 's)';
								this.downCount--;
								if (this.downCount <= 0) {
									this.btnText = '获取验证码';
									this.downCount = 60;
									this.btnDisabled = false;
									clearInterval(this.timer);
									this.timer = null;
								}
							}, 1000);
						}
					})
					.catch(err => {
						console.log('sendMessage -> err', err);
						this.btnDisabled = false;
					});
			},
			// 提交注册
			submitClick() {
				var that = this;
				if (that.isCke) {
					return;
				}
				if (!that.zcmodel.Name) {
					that.$util.showError('请输入考生姓名');
					return;
				}
				if (!that.area.length) {
					that.$util.showError('请选择所在地');
					return;
				}
				// if (!that.zcmodel.School) {
				// 	that.$util.showError('请选择学校');
				// 	return;
				// }
				that.UserInfo.Gender = that.zcmodel.Gender;
				that.UserInfo.Type = that.zcmodel.Type;
				that.UserInfo.Name = that.zcmodel.Name;
				that.UserInfo.CollegeYear = that.zcmodel.CollegeYear;
				that.UserInfo.School = that.zcmodel.School;
				that.UserInfo.TeacherId = that.zcmodel.TeacherId ? that.zcmodel.TeacherId : 0;
				that.UserInfo.CityCode = that.area;
				that.UserInfo.InvitationCode=that.zcmodel.InvitationCode;
				that.false = true;
				that.isCke = true;

				that.$api.HtppRequest(
					'user/UpdateUser',
					'POST', {
						Id: that.UserInfo.Id,
						Name: that.UserInfo.Name,
						Img: that.UserInfo.Img,
						Gender: that.UserInfo.Gender,
						Type: that.UserInfo.Type,
						CollegeYear: that.UserInfo.CollegeYear,
						CityCode: that.UserInfo.CityCode,
						School: that.UserInfo.School,
						TeacherId: that.UserInfo.TeacherId,
						InvitationCode:that.UserInfo.InvitationCode,
					},
					function(res) {
						if (res.code === 0) {
							that.lock = false;
							that.$util.showOk(res.msg);
							setTimeout(() => {
								that.$router.push('/login');
							}, 1000);
						}
						that.isCke = false;
					},
					function(err) {
						console.log(err);
						that.isCke = false;
					}
				);

				// this.$api
				// 	.register(this.model)
				// 	.then(res => {
				// 		this.lock = false;
				// 		this.$util.showOk(res.msg);
				// 		setTimeout(() => {
				// 			this.$router.push('/login');
				// 		}, 1000);
				// 	})
				// 	.catch(err => {
				// 		this.isCke = false;
				// 		this.lock = false;
				// 		console.error('validateRegister -> err', err);
				// 	});
			}
		}
	};
</script>
<style scoped>
	.shu_div {
		width: 90px;
		height: 100%;
		position: absolute;
		right: 0;
		top: 0;
		z-index: 1;
	}

	*>>>.area-select.medium {
		margin-left: 0;
		height: 40px;
		line-height: 40px;
		margin-right: 10px;
		border-color: #333;
	}

	*>>>.area-selectable-list .area-select-option.selected {
		color: #333;
	}

	*>>>.area-select.medium span {
		padding-top: 0;
		padding-bottom: 0;
	}

	*>>>.area-select-wrap {
		display: flex;
	}

	.login_neiForm .btn {
		width: calc(100% - 100px);
	}

	.regsit_div p {
		width: calc(100% - 100px);
		font-size: 14px;
		color: #ff0000;
	}

	.regsit_city {
		overflow: hidden;
		width: 32%;
	}

	/* regsit_city */

	.years {
		width: calc(100% - 100px);
	}

	*>>>.el-input__inner {
		color: #333;
	}

	*>>>.el-input__inner,
	*>>>.el-input__inner:hover {
		border-color: #333;
	}

	.regsit_radio {
		margin-right: 3em;
	}

	.regsit_radio label {
		margin-left: 10px;
		width: auto !important;
	}

	.regsit_div .login_input {
		width: calc(100% - 110px);
		margin-bottom: 0;
	}

	.regsit_div {
		width: calc(100% - 110px);
		margin-left: 20px;
	}

	/*regsit_div*/

	.login_neiForm ul li label span {
		color: #ee0a24;
	}

	.login_neiForm ul li label {
		width: 90px;
		text-align: right;
		font-size: 14px;
	}

	.login_neiForm ul li {
		margin-bottom: 20px;
	}

	.login_neiForm {
		width: 540px !important;
	}

	/*login_neiForm*/

	.login_nei hgroup span {
		font-size: 14px;
		color: #999;
		position: relative;
		padding-left: 20px;
		cursor: pointer;
	}

	.login_nei hgroup span:hover {
		opacity: 0.7;
	}

	.login_nei hgroup {
		overflow: hidden;
		margin-top: 20px;
	}

	.sendCode {
		overflow: hidden;
		width: 180px;
		font-size: 14px;
		color: #333;
		position: relative;
		text-align: center;
		cursor: pointer;
	}

	.sendCode::after {
		content: '';
		width: 2px;
		height: 14px;
		background-color: #333;
		position: absolute;
		left: 0;
		top: 50%;
		margin-top: -7px;
		z-index: 1;
	}

	/*sendCode*/

	.regsit_yan {
		margin-bottom: 20px;
		overflow: hidden;
		border-radius: 4px;
		height: 40px;
		border: solid 1px #06222c;
		width: 90px;
		box-sizing: border-box;
		cursor: pointer;
	}

	.regsitFlex .login_input {
		width: calc(100% - 100px);
	}

	.regsitFlex {
		overflow: hidden;
	}

	/*regsitFlex*/

	.btn {
		display: block;
		width: 100%;
		background-color: #333;
		border-color: #333;
		cursor: pointer;
	}

	.login_box p span {
		color: #333;
		cursor: pointer;
	}

	.login_box p {
		font-size: 14px;
		margin-left: 0.5em;
	}

	.login_box {
		margin-bottom: 30px;
	}

	/*login_box*/

	.login_input input::-webkit-input-placeholder,
	*>>>.el-input__inner::-webkit-input-placeholder {
		color: #999;
	}

	.login_input input:-moz-placeholder,
	*>>>.el-input__inner::-moz-placeholder {
		color: #999;
	}

	.login_input input:-ms-input-placeholder,
	*>>>.el-input__inner::-ms-input-placeholder {
		color: #999;
	}

	.login_input input {
		overflow: hidden;
		width: calc(100% - 30px);
		padding-left: 10px;
		font-size: 14px;
		color: #333;
		display: block;
		height: 100%;
		position: relative;
	}

	.login_input img {
		display: block;
		width: 20px;
		height: 20px;
	}

	.login_input {
		margin-bottom: 20px;
		overflow: hidden;
		border-radius: 4px;
		height: 40px;
		border: solid 1px #06222c;
		padding: 0 10px;
		width: 100%;
		box-sizing: border-box;
	}

	.login_nei {
		width: 340px;
		margin: 60px auto 0 auto;
	}

	/*login_nei*/

	.login h1::after {
		content: '';
		width: 160px;
		height: 6px;
		background-color: #333;
		position: absolute;
		left: 50%;
		margin-left: -80px;
		bottom: 0;
		z-index: 1;
	}

	.login h1 {
		padding: 10px 0 30px 0;
		overflow: hidden;
		border-bottom: solid 2px #333;
		font-size: 18px;
		color: #333;
		text-align: center;
		position: relative;
	}

	.login {
		width: 1200px;
		margin: 40px auto;
		background-color: #fff;
		padding: 20px;
		min-height: 50vh;
	}

	.area-select-wrap {}
</style>
